const EventBus = {
  events: {},

  $on(event, fn) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(fn);
  },

  $off(event, fn) {
    if (!this.events[event]) return;
    if (!fn) {
      delete this.events[event];
    } else {
      this.events[event] = this.events[event].filter((f) => f !== fn);
    }
  },

  $emit(event, ...args) {
    if (!this.events[event]) return;
    this.events[event].forEach((fn) => fn(...args));
  },
};

export default EventBus;
